// Shared country utilities
// Provides a common COUNTRY_MAP and helpers to render country info consistently across the app.

export interface CountryInfo {
  code: string; // ISO 3166-1 alpha-2 code, uppercased
  name: string;
  flag: string; // emoji flag or placeholder
}

// Minimal set based on current products/back-end responses. Extend as needed.
export const COUNTRY_MAP: Record<string, { name: string; flag: string }> = {
  AU: { name: 'Australia', flag: '🇦🇺' },
  CA: { name: 'Canada', flag: '🇨🇦' },
  DE: { name: 'Germany', flag: '🇩🇪' },
  FI: { name: 'Finland', flag: '🇫🇮' },
  GB: { name: 'United Kingdom', flag: '🇬🇧' },
  IN: { name: 'India', flag: '🇮🇳' },
  NL: { name: 'Netherlands', flag: '🇳🇱' },
  SG: { name: 'Singapore', flag: '🇸🇬' },
  US: { name: 'United States', flag: '🇺🇸' },
};

export function normalizeCountryCode(code?: string | null): string {
  if (!code) return '';
  return String(code).trim().toUpperCase();
}

export function getCountryInfo(code?: string | null): CountryInfo {
  const normalized = normalizeCountryCode(code);
  const info = normalized ? COUNTRY_MAP[normalized] : undefined;
  if (info) return { code: normalized, name: info.name, flag: info.flag };
  // Fallback: show code as name when unknown; use white flag.
  const fallback = normalized || 'N/A';
  console.log(`Unknown country code: ${fallback}`);
  return { code: normalized, name: fallback, flag: '🏳️' };
}
